import styled from "styled-components";

export const ListContent = styled.div`
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100% - 69px);
`;